import {IColumn} from 'models/library/common';

export const learningPathsColumns: IColumn[] = [
  {id: 'name', label: 'Name'},
  {id: 'programYear', label: 'Program Year'},
  {id: 'status', label: 'Status'},
  {id: 'resourcesCount', label: 'Resources', align: 'right'},
  {id: 'actions', label: '', align: 'right'},
];
